<template>
  <div class="EndQA">
    <div class="chatbot-eq">
      <el-avatar class="chat-avatar" :src="chatHead"></el-avatar>
      <div class="chatbot-q-content">
        <p>{{ tip }}</p>
        <div>
          <el-button class="q-btn" :disabled="disableYesBtn" @click="getYes('是')">是</el-button >
          <el-button class="q-btn" :disabled="disableNoBtn" @click="getNo('否')">否</el-button >
        </div>
      </div>
    </div>
    <div class="clear-float"></div>
  </div>
</template>

<script>
import { sendSatisfactionStatus } from "@/api/chatbot";
import { updateMessageList } from "@/utils/index";
export default {
  name: "EndQA",
  data() {
    // console.log('满意度调查', this.history, this.lastItem);
    return {
      tip: "请问您对智能客服的本次服务满意吗？",
      chatHead: "/static/images/chat-head.png",
      disableNoBtn: !this.lastItem || this.history,
      disableYesBtn: !this.lastItem || this.history,
    };
  },
  watch: {
    lastItem: function (val) {
      this.disableNoBtn = !val;
      this.disableYesBtn = !val;
    },
  },
  methods: {
    getNo: function (value) {
      this.disableYesBtn = true;
      this.disableNoBtn = true;
      const itemId = this.$store.getters.get_itemId;
      const that = this;
      sendSatisfactionStatus({
        is_status: value,
        item_id: itemId,
        tip: this.tip,
      });
      updateMessageList(that, itemId);
      this.$store.commit("set_messageList", { userInput: value, type: "qa", });
      this.$store.commit("set_messageList", { title: "感谢您的支持！小助手会努力改进哦~<br />您还可以继续咨询<b>【热门问题】</b>。", type: "Top3QaRecommend", });
      setTimeout(() => {
        this.$store.commit("set_messageList", { title: "若想咨询<b>【更多问题】</b>，欢迎您选择问题类型按钮或直接在对话框输入关键字搜索问题。", type: "Welcome", });
        this.$store.commit("set_messageList", { type: "ChatbotService", });
      }, 2000);
      window.serviceDelay = true;
    },
    getYes: async function (value) {
      // console.log('getYes')
      this.disableYesBtn = true;
      this.disableNoBtn = true;
      const itemId = this.$store.getters.get_itemId;
      const that = this;
      sendSatisfactionStatus({
        is_status: value,
        item_id: itemId,
        tip: this.tip,
      });
      updateMessageList(that, itemId);
      this.$store.commit("set_messageList", { userInput: value, type: "qa", });
      this.$store.commit("set_messageList", { title: "感谢您的支持！您还可以继续咨询<b>【热门问题】</b>。", type: "Top3QaRecommend", });
      setTimeout(() => {
        this.$store.commit("set_messageList", { title: "若想咨询<b>【更多问题】</b>，欢迎您选择问题类型按钮或直接在对话框输入关键字搜索问题。", type: "Welcome", });
        this.$store.commit("set_messageList", { type: "ChatbotService", });
      }, 2000);
      window.serviceDelay = true;
    },
  },
  props: {
    lastItem: Boolean,
    history: Boolean,
  },
};
</script>

<style>
.chatbot-eq {
  position: relative;
  float: left;
  width: 85%;
  text-align: left;
  padding-left: 40px;
  margin-bottom: 10px;
}
.chatbot-q-content {
  line-height: 27px;
  margin-top: 10px;
  border: 1px solid #efefef;
  padding-left: 10px;
  border-top-right-radius: 25px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding-bottom: 10px;
}
.chatbot-q-content p span {
  text-decoration: underline;
}
.q-btn {
  background-color: #fff;
  border-color: #d72618;
  color: #d72618;
  padding: 5px 22px !important;
  border-radius: 25px;
}
.chat-avatar {
  width: 40px;
  height: 40px;
  position: absolute;
  top: -20px;
  left: 0;
}
.clear-float {
  clear: both;
}
.red {
  color: #d72618;
}
</style>